document.addEventListener("DOMContentLoaded", function () {
    const amPlanRadio = document.querySelector("#am-plan");
    const amPmPlanRadio = document.querySelector("#am-pm-plan");

    const morningForm = document.querySelector("#morning-form");
    const eveningForm = document.querySelector("#evening-form");

    const morningQty = morningForm.querySelector(".quantity-input");
    const eveningQty = eveningForm.querySelector(".quantity-input");

    // Set initial state for AM Plan
    function showAMPlan() {
        morningForm.style.display = "block";
        eveningForm.style.display = "none";

        morningQty.value = 5;
        eveningQty.value = 0;
    }

    // Set state for AM + PM Plan
    function showAMPMPlan() {
        morningForm.style.display = "block";
        eveningForm.style.display = "block";

        morningQty.value = 5;
        eveningQty.value = 5;
    }

    // Event listeners
    amPlanRadio.addEventListener("change", function () {
        if (amPlanRadio.checked) {
            showAMPlan();
        }
    });

    amPmPlanRadio.addEventListener("change", function () {
        if (amPmPlanRadio.checked) {
            showAMPMPlan();
        }
    });

    // Initialize based on default selected plan
    if (amPlanRadio.checked) {
        showAMPlan();
    } else if (amPmPlanRadio.checked) {
        showAMPMPlan();
    }
});
